import { useSyncExternalStore } from 'react';

/****************
 * ONE SWITCH FOR "SHOW WHO WE HIDE", SHARED BY THE DASHBOARD AND THE TRADERS
 * PAGE. Guillaume, 2026-10-15: heavy losers and traders with little history
 * are reachable from both pages, so a trader never shows on one and vanishes
 * on the other.
 *
 * Held in memory, not saved: off on every load, as the Dashboard's switch has
 * always been ("off on every load, never remembered") -- shared while the
 * visit lasts, forgotten on reload.
 ****************/
let on = false;
const listeners = new Set<() => void>();

export function setIncludeHidden(v: boolean): void {
  if (v === on) return;
  on = v;
  listeners.forEach((l) => l());
}

export function useIncludeHidden(): [boolean, (v: boolean) => void] {
  const v = useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => on,
    () => false,
  );
  return [v, setIncludeHidden];
}
